export default __webpack_public_path__ + "static/media/database_search.0d45a1f7.png";